
import {
  IconButton,
  styled
} from "@mui/material";
import { Form } from "formik";

export const StyledAccountData = {

  Title: styled('div')(({ theme }) => ({
    fontSize: "22px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 500,
    lineHeight: 1.6,
    letterSpacing: "0.0075em",
    color: "#484848",
    marginBottom: "8px",
  })),
  Subtitle: styled('div')(({ theme }) => ({
    fontSize: "17px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 400,
    lineHeight: 1.6,
    letterSpacing: "0.0075em",
    color: "grey",
    marginBottom: "8px",
    marginLeft: "15px",
  })),
  Error: styled('div')(({ theme }) => ({
    fontSize: "15px",
    fontFamily: "Roboto, sans-serif",
    lineHeight: 1.6,
    letterSpacing: "0.0075em",
    color: "grey",
    marginBottom: "8px",
    marginLeft: "15px",
  })),
  SubtitleMail: styled('div')(({ theme }) => ({
    fontSize: "13px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 400,
    lineHeight: 1.6,
    letterSpacing: "0.0075em",
    color: "grey",
    marginBottom: "8px",
    marginLeft: "15px",
  })),

  Container: styled('div')(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "15px",
  })),
}

export const StyledEstadoButton = {
  Icon: styled(IconButton)(({ theme, color }) => ({
    color: color ? color : theme.palette.primary.menuItem,
  })),
  Container: styled('div')(({ theme }) => ({
    display: "flex",
    margin: "10px"
  }))
}

export const StyledCuentaCorrienteTable = {
  FilterItem: styled('div')(({ theme }) => ({
    margin: "10px 0px 10px 25px",
    "& p": {
      fontSize: 12,
      marginTop: 5,
      color: "red",
    },
  })),
  TitleContainer: styled('div')(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
  })),
  FilterContainer: styled(Form)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
  })),
  ButtonContainer: styled('div')(({ theme }) => ({
    margin: "20px 0px 0px 30px",
  })),
  ToolbarActionsContainer: styled('div')(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    width: "fit-content",
  })),
}